// extracted by mini-css-extract-plugin
export default {"textarea":"AutoExpandTextarea_textarea__BkIKi","lightMode":"AutoExpandTextarea_lightMode__JUroR","darkMode":"AutoExpandTextarea_darkMode__GTwNj"};